module.exports = __webpack_public_path__ + "img/level1.5c92e2ba.svg";